import FormattedDate from './FormattedDate';

export default FormattedDate;
